'use client'

import { useMemo } from 'react'
import { getProductAndAddDefaultUtmsToLink } from 'utils/queryManipulation'
import { preserveQueryParams } from 'utils/shared'
import { LinkButton } from 'components/Contentful'

export default function EmailCta({ emailCta }) {
  const memoHref = useMemo(() => {
    return getProductAndAddDefaultUtmsToLink(preserveQueryParams(emailCta.linkHref, {}))
  }, [emailCta.linkHref])

  return (
    <div className="flex flex-col justify-center items-center w-full pb-8">
      <LinkButton
        className="min-w-[105px] h-[47px]"
        content={{ ...emailCta, linkHref: memoHref }}
        typographicOptions={{
          fontWeight: 'medium',
          'data-testid': `email-cta-button-text`,
          className: 'min-w-[105px] text-center',
        }}
        color={'primary'}
        data-testid={`email-cta-button`}
        track={{
          ...{
            list_name: 'Email CTA',
            click_id: emailCta.linkText?.json.content?.[0]?.content[0]?.value,
            click_text: emailCta.linkText?.json.content[0]?.content[0]?.value,
            click_url: memoHref,
            click_position: '0',
            track_event: 'internal_campaign_click',
            event_action: 'button_click',
            event_type: 'button_click',
          },
          ...emailCta.event,
        }}
      />
    </div>
  )
}
